import PropTypes from "prop-types";
import { useContext, useEffect, useMemo, useState } from "react";
import sanitize from "sanitize-html";
import { AppContext } from "../../App.context";
import { shuffleArray } from "../../helpers/general";

import { Answer } from "../Answer/Answer";
import { Button } from "../Button";
import {
  QuestionText,
  QuestionWrapper,
  AnswersWrapper,
} from "./Question.style";

const BUTTON_STATUS = {
  CHECK: "Sprawdz",
  NEXT: "Kolejne pytanie",
};

export const Question = ({ question, answers, onNext }) => {
  const { addPoints } = useContext(AppContext);
  const [maxCorrectAns, setMaxCorrectAns] = useState(0);
  const shuffledAnswers = useMemo(() => shuffleArray(answers), [answers]);
  const [selected, setSelected] = useState([]);
  const [buttonStatus, setButtonStatus] = useState(BUTTON_STATUS.CHECK);
  const handleClickAnswer = (answer) => {
    setSelected((prevState) => {
      if (maxCorrectAns <= 1) {
        return [answer];
      }
      const isSelected = prevState.find(
        (element) => element.index === answer.index
      );

      if (!isSelected) return [...prevState, answer];
      return prevState.filter((element) => element.index !== answer.index);
    });
  };

  const handleClick = () => {
    if (buttonStatus === BUTTON_STATUS.CHECK) {
      const isAllSelectedCorrect = selected.every(
        (element) => element.answer_value
      );
      if (isAllSelectedCorrect && selected.length === maxCorrectAns) {
        addPoints();
      }
      setButtonStatus(BUTTON_STATUS.NEXT);
      return;
    }
    setButtonStatus(BUTTON_STATUS.CHECK);
    setSelected([]);
    onNext();
  };

  useEffect(() => {
    setMaxCorrectAns(
      answers.reduce((pv, cv) => {
        return pv + (cv.answer_value ? 1 : 0);
      }, 0)
    );
  }, [answers]);

  return (
    <QuestionWrapper>
      <QuestionText
        dangerouslySetInnerHTML={{
          __html: sanitize(question || "", {
            allowedTags: ["p", "a", "img"],
            allowedAttributes: {
              img: ["src", "srcset"],
            },
          }),
        }}
      />
      <AnswersWrapper>
        {shuffledAnswers.map((answer, index) => (
          <Answer
            key={`ANS${index}`}
            index={index}
            {...answer}
            onSelect={handleClickAnswer}
            selected={!!selected?.find((element) => element.index === index)}
            disabled={buttonStatus === BUTTON_STATUS.NEXT}
          />
        ))}
      </AnswersWrapper>
      {selected && <Button onClick={handleClick}>{buttonStatus}</Button>}
    </QuestionWrapper>
  );
};

Question.propTypes = {
  image: PropTypes.bool,
  image_size: PropTypes.string,
  question: PropTypes.string,
  answers: PropTypes.array,
  onNext: PropTypes.func,
};
